export default __webpack_public_path__ + "static/media/pic11.bd640584.jpg";